import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Row, Col } from 'antd';
import InputText from 'components/InputText';
import Titulo from 'components/Titulo';
import { fetchObterEnderecoPorCep } from 'store/fetchActions/fetchEndereco';
import { MSG_ERRO_CEP } from 'utils/consts';
import { carregarEnderecoApi, changeCep } from './Endereco';
import * as S from './styles';

export default function ComponentEndereco({
  titulo,
  control,
  onChange,
  errors,
  getValues,
  setValue,
  setError,
  disabled,
  atributo,
}) {
  const dispatch = useDispatch();

  const getNomeCampo = campo => (atributo ? `${atributo}.${campo}` : campo);
  const [disabledInput, setDisabledInput] = useState({});

  useEffect(() => {
    if (getValues?.(getNomeCampo('cep'))) {
      setDisabledInput({
        logradouro: true,
        bairro: true,
        cidade: true,
        estado: true,
        pais: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // AO DIGITAR O CEP, BUSCA O ENDEREÇO COMPLETO
  // CASO ENCONTRE PREENCHE OS CAMPOS ENCONTRADOS E DEIXA BLOQUEADO
  // CASO NÃO ENCONTRE LIMPA OS CAMPOS ENCONTRADOS E DEIXA LIBERADOS
  const buscarEndereco = cep => {
    dispatch(fetchObterEnderecoPorCep(cep))
      .then(endereco => {
        const { disabled } = carregarEnderecoApi(endereco, cep, setValue, setError, getNomeCampo);
        setDisabledInput(disabled);
      })
      .catch(() => {
        setDisabledInput({});
        setError(getNomeCampo('cep'), { type: 'Custom', message: MSG_ERRO_CEP });
      });
  };

  return (
    <S.Contain>
      {titulo && <Titulo textTitle={titulo} />}
      <Row justify="start">
        <Col xs={24} sm={16} md={8} lg={7} xl={3}>
          <InputText
            label="* CEP"
            name={getNomeCampo('cep')}
            errors={errors}
            placeholder={'Informe o CEP'}
            control={control}
            onChange={event => changeCep(event, onChange, setValue, buscarEndereco, getNomeCampo)}
            maxLength={9}
            disabled={disabled}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={7} xl={7}>
          <InputText
            label="* Logradouro"
            name={getNomeCampo('logradouro')}
            errors={errors}
            placeholder={'Informe o logradouro'}
            control={control}
            onChange={onChange}
            maxLength={150}
            disabled={disabled || disabledInput?.logradouro}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={7} xl={7}>
          <InputText
            label="Complemento"
            name={getNomeCampo('complemento')}
            errors={errors}
            placeholder={'Informe o complemento'}
            control={control}
            onChange={onChange}
            maxLength={150}
            disabled={disabled || disabledInput?.complemento}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={8} xl={2}>
          <InputText
            label="* Número"
            name={getNomeCampo('numero')}
            errors={errors}
            placeholder={'Número'}
            control={control}
            onChange={onChange}
            maxLength={6}
            disabled={disabled || disabledInput?.numero}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={8} xl={4}>
          <InputText
            label="* Bairro"
            name={getNomeCampo('bairro')}
            errors={errors}
            placeholder={'Informe o bairro'}
            control={control}
            onChange={onChange}
            maxLength={100}
            disabled={disabled || disabledInput?.bairro}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={8} xl={4}>
          <InputText
            label="* Cidade"
            name={getNomeCampo('cidade')}
            errors={errors}
            placeholder={'Informe a cidade'}
            control={control}
            onChange={onChange}
            maxLength={50}
            disabled={disabled || disabledInput?.cidade}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={8} xl={3}>
          <InputText
            label="* Estado"
            name={getNomeCampo('estado')}
            errors={errors}
            placeholder={'Informe o estado'}
            control={control}
            onChange={onChange}
            maxLength={50}
            disabled={disabled || disabledInput?.estado}
          />
        </Col>
        <Col xs={24} sm={16} md={8} lg={8} xl={3}>
          <InputText
            label="* País"
            name={getNomeCampo('pais')}
            errors={errors}
            placeholder={'Informe o país'}
            control={control}
            onChange={onChange}
            disabled={disabled || disabledInput?.pais}
            maxLength={20}
          />
        </Col>
      </Row>
    </S.Contain>
  );
}

ComponentEndereco.propTypes = {
  titulo: PropTypes.string,
  control: PropTypes.object,
  onChange: PropTypes.func,
  errors: PropTypes.object,
  setValue: PropTypes.func,
  setError: PropTypes.func,
  disabled: PropTypes.bool,
};

ComponentEndereco.defaultProps = {
  // titulo: '',
  // control: {},
  // onChange: () => {},
  // errors: {},
  // setValue: () => {},
  // setError: () => {},
  // disabled: false,
};
